export default __webpack_public_path__ + "static/media/background-sign.9d6bb86a.jpg";